import {AwsS3MultipartOptions} from "@uppy/aws-s3-multipart";
import {getApiClient} from "../../../apiClient";

export default function abortMultipartUpload(authToken: string): AwsS3MultipartOptions['abortMultipartUpload'] {
  const apiClient = getApiClient(authToken)
  return async (file, { uploadId, key}) => {
    await apiClient.abortMultipartUpload(key, uploadId)
  }
}
